<template>
  <b-card>
    <b-table
      per-page="7"
      :current-page="currentPage"
      class="text-center"
      :fields="[
        { key: 'status', label: 'Status' },
        { key: 'transaction_date', label: 'Data' },
        { key: 'authorization_number', label: 'Autorização' },
        { key: 'host_nsu', label: 'Host' },
      ]"
      :items="tableData"
    >

    <template #cell(transaction_date)="data">
        {{ data.item.transaction_date | date }}
    </template>

    </b-table>

    <BPagination
      v-model="currentPage"
      per-page="7"
      :total-rows="tableData.length"
      class="mt-1"
      align="center"
    />
  </b-card>
</template>

<script>
import { BTable, BCard, BPagination } from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BCard,
    BPagination,
  },

  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentPage: 1,
    }
  },
}
</script>

<style>

</style>
